import classNames from "classnames";
import { Persona } from "components/Persona/Persona";
import { delayOnOutsideClick } from "helpers";
import { createLogger } from "logging";
import { usePermissions } from "providers";
import { useTranslations } from "providers";
import { useAuthentication } from "providers/Authentication/useAuthentication";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

const logger = createLogger("UserMenu");

interface UserMenuProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({ isOpen, setIsOpen }) => {
  const outsideClickRef = useRef<HTMLDivElement>(null!);
  useOnClickOutside(outsideClickRef, () => {
    delayOnOutsideClick(logger, isOpen, setIsOpen);
  });

  const i18n = useTranslations();
  const { permissions } = usePermissions();
  const { logout } = useAuthentication();

  const user = permissions?.user;
  if (!user) {
    return;
  }

  const buttonId = "userMenuButton";
  const buttonClass = classNames("btn", "btn-link", "dropdown-toggle", isOpen ? "show" : "");
  const menuClass = classNames("dropdown-menu", isOpen ? "show" : "");

  return (
    <div className="sbb-header-nav-item" ref={outsideClickRef}>
      <div className="dropdown" onClick={() => setIsOpen(!isOpen)} aria-hidden="true">
        <button
          className={buttonClass}
          type="button"
          id={buttonId}
          aria-haspopup="true"
          aria-expanded={isOpen ? "true" : "false"}
        >
          <div className="sbb-header-persona hide-on-mobile">
            <Persona user={user} title={user.displayName} hideUrl={true} />
          </div>
          <div className="sbb-header-persona hide-on-desktop">
            <Persona user={user} title={user.initials} hideUrl={true} />
          </div>

          <div className="sbb-header-nav-item-icon ms-2">
            <i className="ms-Icon ms-Icon--ChevronDown" />
          </div>
        </button>

        <div className={menuClass} aria-labelledby={buttonId}>
          <div className="dropdown-inner">
            <button className="dropdown-item" onClick={() => logout()} type="button">
              {i18n.Logout}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
